import { Grid2 } from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableGalleryItem = ({ id, size = 3, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
    const style = { transform: CSS.Transform.toString(transform), transition };

    return (
        <Grid2 ref={setNodeRef} container size={size} style={{ ...style, cursor: isDragging ? 'grabbing' : 'grab' }} {...attributes} {...listeners}>
            {children}
        </Grid2>
    );
};

export default SortableGalleryItem;
